import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class IdleTimeoutService {

  private idleTimeout: any;
  private idleTimeLimit = 60 * 60 * 1000;

  constructor(private zone: NgZone, private router: Router) { }

  startWatching(logoutCallback: Function) {
    this.resetTimer(logoutCallback);

    // reset timer on user actions
    window.addEventListener('mousemove', () => this.resetTimer(logoutCallback));
    window.addEventListener('keypress', () => this.resetTimer(logoutCallback));
    window.addEventListener('click', () => this.resetTimer(logoutCallback));
    window.addEventListener('scroll', () => this.resetTimer(logoutCallback));
  }

  private resetTimer(logoutCallback: Function) {
    // Use NgZone to avoid Angular change detection overhead
    this.zone.runOutsideAngular(() => {
      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout);
      }

      this.idleTimeout = setTimeout(() => {
        this.zone.run(() => logoutCallback());
      }, this.idleTimeLimit);
    });
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/idle-timeout.service.ts